<div class="alert-stack" aria-live="polite" aria-atomic="false">
  @for (alert of alertService.alerts(); track alert.id) {
    <div class="app-alert" [class]="'app-alert--' + alert.type" role="alert">
      <span class="app-alert__icon" aria-hidden="true">
        @switch (alert.type) {
          @case ('success') { ✓ }
          @case ('error') { ! }
          @case ('warning') { ! }
          @default { i }
        }
      </span>
      <p class="app-alert__message">{{ alert.message }}</p>
      <button
        type="button"
        class="app-alert__close"
        (click)="alertService.dismiss(alert.id)"
        aria-label="Dismiss alert"
      >
        ×
      </button>
    </div>
  }
</div>
